import React, { Suspense } from 'react'
import { renderRoutes } from 'react-router-config'
import { makeStyles } from '@material-ui/styles'
import { LinearProgress } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  content: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
}))

export const Auth = (props) => {
  const { route } = props

  const classes = useStyles()

  return (
    <main className={classes.content}>
      <Suspense fallback={<LinearProgress />}>{renderRoutes(route.routes)}</Suspense>
    </main>
  )
}
